<template>
  <div>
    <div class="input-label">{{ label }}</div>
    <div class="">
      <div class="add-files--photos">
        <div class="add-files--photo" v-if="photo.length" v-for="(f, key) in photo" :key="key">
          <v-avatar class="add-files--image-wrap" tile size="72">
            <img class="add-files--image" :src="f.url || f.base64" alt="image"/>
            <div class="add-files--magnifying-glass-wrapper" @click="openFullScreen(f.url || f.base64)">
              <v-icon class="add-files--magnifying-glass-icon">mdi-magnify</v-icon>
            </div>
          </v-avatar>
          <i v-if="!disabled" @click="$emit('delete', key)" class="add-files--image-delete">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                fill="#D60000"/>
              <path
                d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                fill="white"/>
            </svg>
          </i>
        </div>
        <div class="add-files--photo" v-if="photo.length < maxFiles">
          <div class="auth-form--wrap add-photo">
            <v-file-input
              multiple
              class="mt-0 pt-0"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera-plus-outline"
              @change="TransformFile"
              :rules="[rules.maxFiles, rules.minFiles, rules.fileSize]"
              :hide-input="true"
              :disabled="disabled"
              required
            />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Photo',
  props: {
    photo: {
      type: Array,
      required: true,
      default: [],
    },
    maxFiles: {
      type: Number,
      default: 1,
    },
    minFiles: {
      type: Number,
      default: 0,
    },
    maxFileSize: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      overlayId: 'imageFullScreen',
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        maxFiles: () => this.photo.length < this.maxFiles || `Количество файлов не более ${this.maxFiles}`,
        minFiles: () => (!Number.isNaN(Number(this.minFiles)) && this.photo.length >= this.minFiles) || `Количество файлов не менее ${this.minFiles}`,
        fileSize: v => !v || !v.size || v.size < 5242880 || 'Максимальный размер файла 5мб',
      },
    };
  },
  methods: {
    openFullScreen(imgSrc) {
      const overlay = document.createElement('div');
      overlay.id = this.overlayId;
      overlay.style.position = 'absolute';
      overlay.style.background = '#00000073';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.zIndex = '500';
      overlay.style.display = 'flex';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';

      const imageContainer = document.createElement('div');
      imageContainer.style.position = 'absolute';
      imageContainer.style.backgroundSize = 'contain';
      imageContainer.style.backgroundPosition = 'center';
      imageContainer.style.opacity = '1';
      imageContainer.style.height = '80%';

      const image = document.createElement('img');
      image.style.height = '100%';
      image.style.width = '100%';
      image.style.objectFit = 'cover';
      image.src = imgSrc;

      imageContainer.appendChild(image);

      const closeButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      closeButton.setAttribute('width', '26');
      closeButton.setAttribute('height', '26');
      closeButton.setAttribute('viewBox', '0 0 26 26');
      closeButton.setAttribute('fill', 'none');

      closeButton.style.position = 'absolute';
      closeButton.style.right = '-12px';
      closeButton.style.top = '-12px';
      closeButton.style.cursor = 'pointer';
      closeButton.addEventListener('click', () => {
        const foundOverlay = document.getElementById(this.overlayId);
        if (foundOverlay) {
          document.body.removeChild(foundOverlay);
        }
      });

      const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path1.setAttributeNS(null, 'd', 'M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z');
      path1.setAttributeNS(null, 'fill', '#D60000');

      const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path2.setAttributeNS(null, 'd', 'M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z');
      path2.setAttributeNS(null, 'fill', 'white');

      closeButton.appendChild(path1);
      closeButton.appendChild(path2);

      imageContainer.appendChild(closeButton);

      overlay.appendChild(imageContainer);
      document.body.appendChild(overlay);
    },
    /** Методы для работы с документами */
    async TransformFile(files, idx) {
      const file = files[0];
      const document = { file: '', url: '', name: '' };
      if (!file || file.name.lastIndexOf('.') <= 0) {
        return document;
      }
      const fr = new FileReader();
      await fr.readAsDataURL(file);
      await fr.addEventListener('load', () => {
        document.name = file.name;
        document.file = null;
        document.base64 = fr.result;
        document.key = `${idx}_${Date.now()}`;
        this.$emit('add', document);
      });
      return document;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-files {
  margin-bottom: 15px;

  &--button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    &-text {
      font-size: 12px;
    }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      align-items: flex-start;
      &-text {
        padding-bottom: 15px;
        padding-left: 0;
      }
    }
  }

  &--list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
    border: 2px dashed #E6E8F0;
    border-radius: 8px;

    .add-photo {
      margin: 15px 30px 15px 0;
    }
  }

  &--photos {
    display: flex;
    flex-wrap: wrap;
  }

  &--photo {
    position: relative;

    &:hover {
      .add-files--magnifying-glass-wrapper {
        transition: opacity 0.3s;
        opacity: 0.5;
        visibility: visible;
        cursor: pointer;
      }
    }
  }

  &--image-wrap {
    margin: 15px 15px 15px 0;
    position: relative;
  }

  &--image {
    border-radius: 8px !important;
  }

  &--image-delete {
    position: absolute;
    top: 2px;
    right: 2px;
  }

  &--image-delete:hover {
    cursor: pointer;
  }

  &--magnifying-glass-wrapper {
    position: absolute !important;
    height: 100%;
    width: 100%;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;
    background: black;
    border-radius: 8px;
  }

  &--magnifying-glass-icon {
    color: white !important;
  }
}
</style>
